export default {
	baseBorderRadius: '4px',
}